import * as Immutable from "immutable";
import ParameterBinding from "../parameters/ParameterBinding";
export default class SearchExecutionState {
  constructor(parameterBindings = Immutable.Map(), globalOverride) {
    this._value = { parameterBindings, globalOverride };
  }
  get parameterBindings() {
    return this._value.parameterBindings;
  }
  get globalOverride() {
    return this._value.globalOverride;
  }
  toBuilder() {
    const { globalOverride, parameterBindings } = this._value;
    return new Builder(Immutable.Map({ globalOverride, parameterBindings }));
  }
  static create(parameterBindings, globalOverride) {
    return new SearchExecutionState(parameterBindings, globalOverride);
  }
  static empty() {
    return new SearchExecutionState();
  }
  toJSON() {
    const { globalOverride, parameterBindings } = this._value;
    return {
      global_override: globalOverride,
      parameter_bindings: parameterBindings
    };
  }
  static fromJSON(value) {
    const { global_override, parameter_bindings } = value;
    return SearchExecutionState.create(parameter_bindings, global_override);
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this.value = value;
  }
  parameterBindings(newBindings) {
    return new Builder(this.value.set("parameterBindings", newBindings));
  }
  globalOverride(globalOverride) {
    return new Builder(this.value.set("globalOverride", globalOverride));
  }
  build() {
    const { globalOverride, parameterBindings } = this.value.toObject();
    return new SearchExecutionState(parameterBindings, globalOverride);
  }
}
const getParameterBindingValue = (executionState, parameterName) => executionState.parameterBindings.get(parameterName, ParameterBinding.empty()).value;
const getParameterBindingsAsMap = (bindings) => bindings.flatMap(
  (binding, name) => Immutable.Map({ [name]: binding.value })
);
export { getParameterBindingsAsMap, getParameterBindingValue };
